import { createSlice } from "@reduxjs/toolkit";

function getExpandedPanels(expandedPanels, expanded, isExpanded) {
  if (expanded === "allPanel") {
    return ["panel1", "panel2", "panel3"];
  }

  if (isExpanded) {
    return expandedPanels.includes(expanded)
      ? expandedPanels
      : [...expandedPanels, expanded];
  }

  return expandedPanels.filter((panel) => panel !== expanded);
}

const initialState = {
  expanded: ["panel1"],
};

const boardList = createSlice({
  name: "boardList",
  initialState,
  reducers: {
    changeExpand: {
      prepare(expanded, isExpanded) {
        return {
          payload: { expanded, isExpanded },
        };
      },
      reducer(state, action) {
        const { expanded, isExpanded } = action.payload;
        state.expanded = getExpandedPanels(
          state.expanded,
          expanded,
          isExpanded
        );
      },
    },
  },
});

export const { changeExpand } = boardList.actions;

export default boardList.reducer;
